import type { User } from "../models/user-model";
import { db } from "./db";

export const DB_USER_ID = "current";

export const UserRepository = {
    async set(user: User) {
        await db.user.put({ ...user, id: DB_USER_ID });
    },

    async get(): Promise<User | undefined> {
        return db.user.get(DB_USER_ID);
    },

    async remove() {
        await db.user.delete(DB_USER_ID);
    },

    async update(changes: Partial<User>) {
        await db.user.update(DB_USER_ID, changes);
    },
};
